// extracted by mini-css-extract-plugin
export default {"SeatsRadioButton":"SeatsRadioButton_SeatsRadioButton__GsAT4"};